import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { IconComponent, CobaltButtonModule, CobaltInputModule } from '@msi/cobalt-prime';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AttachmentInputModel } from '@premise-hazard-models/attachment-input.model';

const MAX_ATTACHMENT_BYTES = 1_000_000_000; // 1 GB

@Component({
  selector: 'app-attachment-upload-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslocoDirective, TranslocoPipe, IconComponent, CobaltButtonModule, CobaltInputModule],
  templateUrl: './attachment-upload-dialog.component.html',
  styleUrl: './attachment-upload-dialog.component.scss',
})
export class AttachmentUploadDialogComponent {
  private readonly dialogRef = inject(DynamicDialogRef);
  private selectedFile?: File;

  public readonly attachmentForm = new FormGroup({
    name: new FormControl<string>('', [Validators.required, Validators.minLength(1), Validators.maxLength(255)]),
    description: new FormControl<string>('', [Validators.maxLength(1024)]),
    filePath: new FormControl<string>('', [Validators.required, Validators.minLength(1)]),
  });

  public onFileChanged(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }
    if (file.size >= MAX_ATTACHMENT_BYTES) {
      this.attachmentForm.controls['filePath'].setErrors({ maxSize: true });
      return;
    }
    this.attachmentForm.controls['filePath'].setErrors(null);
    this.selectedFile = file;
  }

  public submit(): void {
    if (!this.attachmentForm.valid || !this.selectedFile) {
      return;
    }
    const attachment: AttachmentInputModel = {
      name: this.attachmentForm.controls['name'].value!,
      description: this.attachmentForm.controls['description'].value!,
      file: this.selectedFile,
    };
    this.dialogRef.close({ attachment, file: this.selectedFile });
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }
}
